<template>
  <div class="fy-file-div">
    <span>{{file_name}}</span>
    <a class="fy-file">
      选择文件
      <input :placeholder="placeholder" @change="handleChange" type="file">
    </a>
  </div>
</template>
<script>
/**
 * 使用例子：
        <fy-form-item label="上传文件" prop="file">
            <fy-file v-model="file"></fy-file>
        </fy-form-item>

        file: '',
 */
import util from '../utils/util.js'
export default {
  name: 'FyFile',

  componentName: 'FyFile',
  mixins: [util], //这些混入实例对象可以像正常的实例对象一样包含选项（可以直接this.*使用混入对象中的方法）

  inject: {
    fyForm: {
      default: ''
    },
    fyFormItem: {
      default: ''
    }
  },
  data () {
    return {
      currentValue: '',
      file_name: '请选择文件'
    }
  },
  props: {
    value: '',
    //file的value值没办法赋初值，只能设置为空字符串
    placeholder: {
      type: String,
      default: ''
    }
  },
  watch: {},
  mounted () {
    this.dispatch('FyFormItem', 'formItem.addChildVc', [this]) //发送添加formitem对象的信息
  },
  methods: {
    resetField () {
      this.$emit('input', '')
      this.file_name = '请选择文件'
    },
    handleChange (event) {
      const file = event.target.files[0]
      const value = event.target.value
      this.$emit('input', file)
      this.dispatch('FyFormItem', 'el.form.change', [value])
      this.file_name = value.substr(value.lastIndexOf('\\') + 1);
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/components/form/form.css';
</style>



// WEBPACK FOOTER //
// src/components/form/file.vue